"use client";

import { useState, type ReactNode } from "react";
import { Menu, X } from "lucide-react";

type MobileMenuShellProps = Readonly<{
  children: (close: () => void) => ReactNode;
}>;

export default function MobileMenuShell({ children }: MobileMenuShellProps) {
  const [isOpen, setIsOpen] = useState(false);
  const close = () => setIsOpen(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="relative p-2 text-gray-700 rounded-md hover:bg-gray-100 transition-colors"
        aria-label={isOpen ? "بستن منو" : "باز کردن منو"}
        aria-expanded={isOpen}
      >
        <span className="relative block size-7">
          <Menu
            size={28}
            className={`absolute inset-0 transition-all duration-200 ease-out ${
              isOpen
                ? "opacity-0 rotate-90 scale-50"
                : "opacity-100 rotate-0 scale-100"
            }`}
          />
          <X
            size={28}
            className={`absolute inset-0 transition-all duration-200 ease-out ${
              isOpen
                ? "opacity-100 rotate-0 scale-100"
                : "opacity-0 -rotate-90 scale-50"
            }`}
          />
        </span>
      </button>

      <div
        className={`fixed top-20 inset-x-0 bottom-0 z-40 transition-opacity duration-300 ${
          isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
      >
        <button
          type="button"
          className="absolute inset-0 bg-black/40 border-0 p-0 cursor-default"
          onClick={close}
          aria-label="بستن منو"
        />

        <div
          className={`absolute top-0 right-0 h-full w-3/5 max-w-xs bg-white border-t border-gray-200 shadow-2xl transform transition-transform duration-300 ${
            isOpen ? "translate-x-0" : "translate-x-full"
          }`}
        >
          <nav className="flex flex-col text-gray-700 font-medium">
            {children(close)}
          </nav>
        </div>
      </div>
    </>
  );
}
